<template>
  <div class="mt-2">
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header :title="$t('roleManagement.roleCardHeader')" :iconName="'person-circle'" />
      <b-card-body>
        <b-overlay :show="isUsersLoading" spinner-variant="primary" rounded="sm">
          <UserRolesTable v-if="rolesTableVisible" :user-roles="userRoles" :user="user" />
          <RoleManagementSearch @search-string-changed="search" />
          <UsersTable class="mt-3" @changeVisibility="setVisibility" :user-list="usersList"
            @user-selected="userSelected" />

        </b-overlay>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import cardHeader from "../components/common/cardHeader";
import RoleManagementSearch from "../components/roleManagement/RoleManagementSearch";
import UsersTable from "../components/roleManagement/UsersTable";
import UserRolesTable from "../components/roleManagement/UserRolesTable";
import EsepService from "../services/esep.service.js";
import { roles, routes } from "../services/routing.service";
import { hasRole } from "../services/utils";

export default {
  name: "roleManagement",
  components: {
    cardHeader,
    RoleManagementSearch,
    UsersTable,
    UserRolesTable,
  },
  mounted() {
    EsepService.getUserInfo(this.username).then(
      (response) => {
        let userInfo = response.data;
        this.$store.state.userInfo = userInfo;
        if (!hasRole(userInfo, roles.users.management)) {
          location.replace(routes.nothing);
        }
        this.fetchAccessibleUnits(this.username);
      }
    );
  },
  data() {
    return {
      rolesTableVisible: false,
      isUserLoading: false,
      userList: [],
      userRoles: [],
      user: {}
    }
  },
  computed: {
    usersList() {
      return this.userList
    },
    isUsersLoading() {
      return this.isUserLoading
    }
  },
  methods:
  {
    setVisibility(value) {
      this.rolesTableVisible = value;
    },
    userSelected(value) {
      this.userRoles = value.userRoles;
      this.user = value.user;
    },
    fetchAccessibleUnits() {
      EsepService.getAccessibleUnits(null, true, null, 'VIEW_UNIT').then(
        (response) => {
          this.$store.state.usersAccessibleUnits = response.data.VIEW_UNIT;
        }
      )
    },
    search(searchString) {
      this.setVisibility(false);
      this.isUserLoading = true;
      EsepService.getUsersByCriteria(searchString).then(
        (response) => {
          this.userList = response.data
          this.$log.debug(response.data);
          this.isUserLoading = false;
        },
        (error) => {
          this.isUserLoading = false;
          this.errorMessage =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
  }
}
</script>